import React from 'react';
import {
  DataGrid,
  GridColDef,
  GridRowsProp,
  GridSortModel,
  GridFilterModel,
  GridPaginationModel,
  GridRowParams,
} from '@mui/x-data-grid';
import { Box, Paper } from '@mui/material';

interface DataTableProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  loading?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
  rowCount?: number;
  paginationMode?: 'client' | 'server';
  sortingMode?: 'client' | 'server';
  filterMode?: 'client' | 'server';
  onPaginationModelChange?: (model: GridPaginationModel) => void;
  onSortModelChange?: (model: GridSortModel) => void;
  onFilterModelChange?: (model: GridFilterModel) => void;
  checkboxSelection?: boolean;
  disableRowSelectionOnClick?: boolean;
  onRowSelectionModelChange?: (ids: any[]) => void;
  autoHeight?: boolean;
  getRowId?: (row: any) => string | number;
  onRowClick?: (params: GridRowParams, event: React.MouseEvent) => void;
}

export const DataTable: React.FC<DataTableProps> = ({
  rows,
  columns,
  loading = false,
  pageSize = 10,
  pageSizeOptions = [5, 10, 25, 50, 100],
  rowCount,
  paginationMode = 'client',
  sortingMode = 'client',
  filterMode = 'client',
  onPaginationModelChange,
  onSortModelChange,
  onFilterModelChange,
  checkboxSelection = false,
  disableRowSelectionOnClick = true,
  onRowSelectionModelChange,
  autoHeight = false,
  getRowId,
  onRowClick,
}) => {
  return (
    <Paper elevation={0} sx={{ width: '100%', borderRadius: 2 }}>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          initialState={{
            pagination: {
              paginationModel: { pageSize, page: 0 },
            },
          }}
          pageSizeOptions={pageSizeOptions}
          rowCount={rowCount}
          paginationMode={paginationMode}
          sortingMode={sortingMode}
          filterMode={filterMode}
          onPaginationModelChange={onPaginationModelChange}
          onSortModelChange={onSortModelChange}
          onFilterModelChange={onFilterModelChange}
          checkboxSelection={checkboxSelection}
          disableRowSelectionOnClick={disableRowSelectionOnClick}
          onRowSelectionModelChange={onRowSelectionModelChange}
          autoHeight={autoHeight}
          getRowId={getRowId}
          onRowClick={onRowClick as any}
          density="compact"
          sx={{
            border: 'none',
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid',
              borderColor: 'divider',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'action.hover',
              borderBottom: '2px solid',
              borderColor: 'divider',
              borderRadius: 0,
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '2px solid',
              borderColor: 'divider',
            },
            '& .MuiDataGrid-row': {
              cursor: onRowClick ? 'pointer' : 'default',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.12)' : '#e3f2fd',
            },
          }}
        />
      </Box>
    </Paper>
  );
};
